<template>
  <div id="content" class="startup_page">
    <div class="row" style="margin-bottom:30px;">
      <div class="col-12">

        <router-link v-if="pool.isLongList" class="back_btn"  :to="'/my_pools/'+this.sf+'/'+this.$route.params.pool">View your lists </router-link>
          <router-link v-else class="back_btn"  :to="'/my_pools/'+this.sf+'/'+this.$route.params.pool+'?noLongList=true'">View your lists </router-link>
      </div>

    </div>
    <DetailAssessment @close="detailAssessment=false" :startup="detailsForCandidate" :dialogVisible="detailAssessment">  </DetailAssessment>
    <ConfirmModal :dialogVisible='dialogRemove' @close="dialogRemove = false" @confirmed="removeStartup($event)" message="Are you sure ? This action can't be canceled." ></ConfirmModal>
    <ConfirmModal :dialogVisible='dialogAffinity' @close="dialogAffinity = false" @confirmed="sendAffinity($event)" message="The selected companies will be synchronized in Affinity" ></ConfirmModal>

    <StartupRunAssessment @close="runassessment=false" :dialogVisible="runassessment"
     @newInternal="newInternal"
     @newInnopearl="newInnopearl"
     @existingInternal="existingInternal">
    </StartupRunAssessment>
    <AddCommentModal :dialogVisible='dialog' :candidate="candidateForComments" @close="closeModal()" @newValueIsProposed="setNewValueComment($event)" formName="Add a comment" ></AddCommentModal>

    <AddToListModal :searchfield="sf" :dialogVisible='dialogList'  @close="closeModalList()" @toExisting="toExisting($event)" @toNew="toNewList($event)"></AddToListModal>

    <!-- <div class="" v-if="!isAssess && pool.isLongList">
     <div class="all_candidates_download_zone ">
       <div class="col-12r">
         <div>
           <span class="title" @click='toggle = !toggle'>Import your candidates
             <img :src="require('@/assets/triangle.svg')" class="triangle" :class='(toggle == true) ? "open" : "not-open"' alt="">
           </span>

         </div>
         <div class="row" v-if="toggle == true" >
           <div class="col-12 col-lg-6 mt20">
               <span class="pool_subtitle ">Step 1</span><br/>
             <a href="/doc/example_import.xlsx" target="_blank" download>Download and complete our template file in Excel format</a><br/>
                  <a href="/doc/example_import.csv" target="_blank" download>Download and complete our template file in CSV format</a>

           </div>
            <div class="col-12 col-lg-6 mt20">
             <span class="pool_subtitle ">Step 2</span>
             <LongListUploader :dialogVisible='dialogFullSetFile' @close="dialogFullSetFile=false" @fileUploaded="setLongList()"  :search_field="this.$route.params.search_field"></LongListUploader>
           </div>
         </div>

       </div>
     </div>
   </div> -->


      <div class="content_div stats">
            <div class="sidePannel" v-if="showNewFilterPannel == true">
                <div class="create_filters">
                    <span class="filter_content_title">Create new filter</span>

                    <NewFilter @submited="refreshFilters"/>

                </div>
            </div>
        <div class="sidePannel" v-if="showSidePanelBasic == true">

          <div class="filters">


            <div class="oneFilter" v-for="(filtre,f) in basicFilters" :key="f">
              <span class="filtreName clickable" @click="filtre.toggled_sidebar = !filtre.toggled_sidebar">
                {{filtre.display_name}}<span v-if="filtre.key =='revenue' "> (millions)</span>
                <sup class="nb_item" v-if="filtre.values.length > 0">{{filtre.values.length}}</sup>
                <sup class="nb_item" v-else-if="filtre.values.min > 0 || filtre.values.max > 0">1</sup>
                <img :src="require('@/assets/triangle.svg')" class="triangle" :class='(filtre.toggled_sidebar == true) ? "open" : "not-open"' alt="">
              </span>
              <div v-if="filtre.toggled_sidebar == true">

              <div class="" v-if="filtre.key =='submitDate' ">
                <div class="moneyEntryLine">
                  <span class="moneyEntryName">From </span><input class="moneyEntryInput input_filtre" type="date" placeholder="DD/MM/YYYY" v-model="filtre.values.from"/>
                </div>
                <div class="moneyEntryLine">
                  <span class="moneyEntryName">To </span> <input class="moneyEntryInput input_filtre" type="date" placeholder="DD/MM/YYYY" v-model="filtre.values.to"/>
                </div>
              </div>
              <div class="" v-else-if="filtre.key =='revenue' ">
                  <div class="moneyEntryLine">
                    <span class="moneyEntryName">From </span><input class="moneyEntryInput input_filtre" type="number" v-model="filtre.values.min"/>
                  </div>
                  <div class="moneyEntryLine">
                    <span class="moneyEntryName">To </span> <input class="moneyEntryInput input_filtre" type="number" v-model="filtre.values.max"/>
                  </div>

                  <!-- <div class="moneyEntryLine">
                    <span class="moneyEntryName">Currency </span>
                    <select class="moneyEntryInput input_filtre" name=""  v-model="filtre.values.devise">
                      <option value="EUR">EUR</option>
                      <option value="USD">USD</option>
                      <option value="CHF">CHF</option>
                    </select>
                </div> -->


              </div>
              <div class="" v-else-if="filtre.key =='linkplus' ">
              <input type="text" class="input_filtre" name="" placeholder="Search" v-model="filtre.filtre">

              <div class="value_possible">
                <label class="checkbox"  v-for="(val,v) in filtre.values_list" :key="v">
                  <div class="checkboxItem"  v-if="val.name.toUpperCase().includes(filtre.filtre.toUpperCase())">


                    <input class="checkbox__input" type="checkbox" v-model="filtre.values" :value="val._id.$oid"/>
                    <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                      <rect width="21" height="21" x=".5" y=".5" fill="#FFF" stroke="#3783C5" rx="3" />
                      <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="4" d="M4 10l5 5 9-9" />
                    </svg>
                    <span class="checkbox__label">{{val.name}}</span>
                          </div>
                  </label>

              </div>
            </div>
              <div class="" v-else>
              <input type="text" class="input_filtre" name="" placeholder="Search" v-model="filtre.filtre">

              <div class="value_possible">
                <label class="checkbox"  v-for="(val,v) in filtre.values_list" :key="v">
                  <div class="checkboxItem"  v-if="val.value.toUpperCase().includes(filtre.filtre.toUpperCase())">


                    <input class="checkbox__input" type="checkbox" v-model="filtre.values" :value="val.value"/>
                    <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                      <rect width="21" height="21" x=".5" y=".5" fill="#FFF" stroke="#3783C5" rx="3" />
                      <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="4" d="M4 10l5 5 9-9" />
                    </svg>
                    <span class="checkbox__label">{{val.name}}</span>
                          </div>
                  </label>

              </div>
            </div>
            </div>
            </div>
          </div>
          <div class="footerPannel">
              <button type="button" name="button" class="btn_invert" @click="showSidePanelBasic = false">Close</button>
              <button type="button" @click="reset_bfilter()" class="btn_invert" name="button">Reset filters</button>

              <button type="button" @click="apply_filter()" class="btn" name="button">Apply filters</button>
          </div>

        </div>
        <div class="row  " >
          <div class="col-12">

            <div class="poolTitle" v-if="pool.isLongList">
              <h2 class="customH2 text-center">Long list
              <span  v-if="sfname"> for <span class="sfname">{{sfname}}</span></span>
            </h2>
            </div>
            <div class="poolTitle" v-else>
                <h2 class="customH2 text-center">
                  <span v-if="pool.name">{{pool.name}}</span>
                  <span v-else>Candidates pools </span>
                <span  v-if="sfname"> for <span class="sfname">{{sfname}}</span></span>
              </h2>
            </div>
            <div class="col-12 col-12 startup_selection_section">
              <div class="super_action_zone mt50">
                <div class="" v-if="pool.isLongList != true">
                  <div class="vselect_container" >
                    <div class="zone_input">
                      <div class="zone_input_header" @click="showMatching = !showMatching">
                        <span class="zone_input_name">Matching filters

                          <small class="nb_item" v-if="selected_filters.length > 0">{{selected_filters.length}}</small>
                          <img :src="require('@/assets/triangle.svg')" class="triangle" :class='(showMatching == true) ? "open" : "not-open"' alt=""></span>

                      </div>

                      <div class="filter_content" v-if='showMatching == true'>
                        <span class="filter_content_title">Available filters</span>
                        <div class="value_possible_matching">
                          <input type="text" class="input_filtre" name="" placeholder="Search" v-model="matching_search_filtre">
                          <label class="checkbox"  v-for="(filtre,f) in filtres" :key="f">
                            <div class="checkboxItem" v-if="filtre.filter_name.includes(this.matching_search_filtre)">


                              <input class="checkbox__input" type="checkbox" v-model="selected_filters" :value="filtre._id.$oid"/>
                              <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                                <rect width="21" height="21" x=".5" y=".5" fill="#FFF" stroke="#3783C5" rx="3" />
                                <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="4" d="M4 10l5 5 9-9" />
                              </svg>
                              <span class="checkbox__label">{{filtre.filter_name}}</span>
                              <span class="checkbox_hover">
                                <div class="onecondition" v-for="(cond, c) in filtre.condition" :key="c">
                                  <span v-if="cond.type =='select'">{{cond.taxonomy_label }} in
                                    <span v-for="(va,v) in cond.values" :key="v">{{va}}<span v-if="v < cond.values.length - 1"> &nbsp; {{cond.operator}} &nbsp;</span></span>
                                     - Weight : {{cond.weight}}
                                  </span>
                                  <span v-if="cond.type =='range'">{{cond.taxonomy_label }} between {{cond.values[0]}} and {{cond.values[1]}} - Weight : {{cond.weight}}</span>
                                  <span v-if="cond.type =='boolean'">{{cond.taxonomy_label }} is {{cond.values}} - Weight : {{cond.weight}}</span>
                                  <span v-if="cond.type =='money'">{{cond.taxonomy_label.toUpperCase() }}
                                    <span v-if="cond.values.min > 0 && cond.values.max > 0">  between {{cond.values.min}} and {{cond.values.max}} {{cond.values.unit}} {{cond.values.devise}}- Weight : {{cond.weight}}</span>
                                    <span v-if="cond.values.min > 0 && cond.values.max == 0">  more than {{cond.values.min}} {{cond.values.unit}} {{cond.values.devise}}- Weight : {{cond.weight}}</span>
                                    <span v-if="cond.values.min == 0 && cond.values.max > 0">  less than {{cond.values.max}} {{cond.values.unit}} {{cond.values.devise}}- Weight : {{cond.weight}}</span>

                                  </span>
                                </div>
                              </span>
                                    </div>
                            </label>

                        </div>
                        <div class="flexBottom">
                          <div class="tooltip-right tooltip-mobile" data-tooltip="To edit your filters, go to My Filters">
                              <img :src="require('@/assets/info.svg')" alt="" class="explanation_needed_icon">
                          </div>
                          <button type="button" @click="showCreateFilter()" class="btn_invert" name="button">+ Create a new filter</button>

                            <button type="button" @click="apply_filter()" class="btn" name="button">Apply filters</button>
                        </div>

                      </div>

                      </div>
                  </div>
                </div>
                  <div class="quicksearch">
                        <input type="text" class="input" placeholder="Search by name"  v-model="quicksearch">
                  </div>
                  <div class="target_score_container" style="" v-if="pool.isLongList != true">
                    <div class="slider_mini_score" style="">


                    <div class="textcaption">
                                  Targeted score
                                </div>
                                <v-slider
                                  v-model="minscore"
                                   color="#DDDDDD"
                                   track-color="#4c81c0"
                                   thumb-color="#4c81c0"
                                   min='0'
                                   max='100'
                                   rounded='20'
                                   :thumb-size="23"
                                   thumb-label="always"
                                   step="1"
                                   track-size="6px"
                                   reverse="true"
                                   @end="scorer"
                                >
                                <template v-slot:prepend>
                                      100
                                       </template>

                                       <template v-slot:append>
                                      0
                                       </template>
                              </v-slider>
                  </div>
                        </div>

                  <div class="tooglerFilter" v-if="pool.isLongList == true">
                    <div class="toogler" @click="showSidePanelBasic = !showSidePanelBasic">
                        FILTER
                        <small class="nb_item" v-if="basicFilters.filter(obj => ((Array.isArray(obj.values) && obj.values.length > 0) || (obj.values.min > 0 || obj.values.max > 0) || (obj.values.from || obj.values.to))).length  > 0">{{basicFilters.filter(obj => ((Array.isArray(obj.values) && obj.values.length > 0) || (obj.values.min > 0 || obj.values.max > 0) || (obj.values.from || obj.values.to))).length  }}</small>
                        <img :src="require('@/assets/filter2024.svg')" class="" alt="">
                    </div>
                  </div>

                </div>

            <!-- <div class="super_action_zone">
             <div class="col-12 mt50 dflex" v-if="pool.isLongList != true">

              <div class="filtre_list_2">


                <div class="target_score_container" style="">
                  <div class="slider_mini_score" style="">


                  <div class="text-caption" style="margin-bottom:20px;text-align:center">
      Targeted score
    </div>
    <v-slider
      v-model="minscore"
       color="#DDDDDD"
       track-color="#4c81c0"
       thumb-color="#4c81c0"
       min='0'
       max='100'
       rounded='20'
       :thumb-size="15"
       thumb-label="always"
       step="1"
       track-size="12px"
       reverse="true"
       @end="scorer"
    >
    <template v-slot:prepend>
          100
           </template>

           <template v-slot:append>
          0
           </template>
  </v-slider>
                </div>
                      </div>


              </div>
            </div>

                  </div> -->

            </div>
        </div>

          <div class="col-12 startup_selection_section mt50">
            <div class="loaderInnopearl " v-if="loading">
              <div class="loaderInnopearlInner">
                <img :src="require('@/assets/loaderInnopearl.svg')" alt="">
                <span>Loading in progress</span>
              </div>

            </div>
              <div class="" v-if="startups && !loading">
                <div class="row">
                  <span class="numberOfStartupResult">
                    <strong>{{startups_quicksearch.length}}</strong> innovator<span v-if="startups_quicksearch.length > 1">s</span>
                  </span>
                </div>
                <div class="new_action_zone">

                    <div class=" flexItCenterButtons">
                      <!-- <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                        <button type="button" class="action_btn_pool" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="generateAssessment" :disabled="are_selected.length == 0">Assess</button>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 1">Please select at least 1 startup</span>
                        </span>
                      </div> -->
                      <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                        <button type="button" class="action_btn_pool" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="runassessment = true"  :disabled="are_selected.length == 0">{{$t("Add to assessment ")}}</button>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 1">Please select at least 1 innovator</span>
                        </span>
                      </div>
                      <div class="zoneBtn" :class="(are_selected.length != 2 && are_selected.length != 3) ? 'enableWhyDisabled' :'ok' ">
                        <router-link class="action_btn_pool"  :class="(are_selected.length != 2 && are_selected.length != 3) ? 'disabledRlink' :'ok' " :to="'/compare_startup_to_assess/'+this.$route.params.search_field+'/'+are_selected[0]+'/'+are_selected[1]+'/'+are_selected[2]">Compare</router-link>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 2">Please select at least 2 innovators</span>
                          <span v-if="are_selected.length > 3">You can compare 3 innovators max</span>
                        </span>
                      </div>
                      <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                        <button type="button" class="action_btn_pool" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="removeFromList" :disabled="are_selected.length == 0">Remove from list</button>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 1">Please select at least 1 innovator</span>
                        </span>
                      </div>
                      <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                        <button type="button" class="action_btn_pool" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="openModalList" :disabled="are_selected.length == 0">Add to a list</button>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 1">Please select at least 1 innovator</span>
                        </span>
                      </div>
                      <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                        <button type="button" class="action_btn_pool" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="dialogRemove = true" :disabled="are_selected.length == 0">Remove</button>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 1">Please select at least 1 innovator</span>
                        </span>
                      </div>
                      <div v-if="showAffinity" class="zoneBtn" :class="(are_selected.length == 0 || are_selected.length > 20) ? 'enableWhyDisabled' :'ok'">
                        <button type="button" class="action_btn_pool" :class="(are_selected.length == 0 || are_selected.length > 20) ? 'disabledRlink' :'ok'" name="button" @click="dialogAffinity = true" :disabled="are_selected.length == 0 || are_selected.length > 20">Affinity</button>
                        <span class="whyDisabled">
                          <span v-if="are_selected.length < 1">Please select at least 1 innovator</span>
                          <span v-if="are_selected.length > 20">Please select up to 20 innovators</span>
                        </span>
                      </div>
                      <div class="zoneBtn">
                        <button type="button" class="selectAllCp" @click="selectAll" v-if='allSelect == false' name="button">Select All</button>

                        <button type="button" class="selectAllCp" @click="unselectAll" v-if='allSelect == true' name="button">Unselect All</button>

                      </div>

                    </div>
                </div>
                 <!-- <div class="col-12 action_zone"> -->
                   <!-- <span class="actionZoneTitle">CHOOSE YOUR ACTION </span>
                  <div class="goRight">
                    <div class="quicksearch">
                        <input type="text" class="input" placeholder="Search by name"  v-model="quicksearch">
                    </div>
                    <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                      <button type="button" class="action_btn" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="generateAssessment" :disabled="are_selected.length == 0">Assess</button>
                      <span class="whyDisabled">
                        <span v-if="are_selected.length < 1">Please select at least 1 startup</span>
                      </span>
                    </div>
                    <div class="zoneBtn" :class="(are_selected.length != 2 && are_selected.length != 3) ? 'enableWhyDisabled' :'ok' ">
                      <router-link class="action_btn"  :class="(are_selected.length != 2 && are_selected.length != 3) ? 'disabledRlink' :'ok' " :to="'/compare_startup_to_assess/'+this.$route.params.search_field+'/'+are_selected[0]+'/'+are_selected[1]+'/'+are_selected[2]">Compare</router-link>
                      <span class="whyDisabled">
                        <span v-if="are_selected.length < 2">Please select at least 2 startups</span>
                        <span v-if="are_selected.length > 3">You can compare 3 startups max</span>
                      </span>
                    </div>
                    <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                      <button type="button" class="action_btn" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="removeFromList" :disabled="are_selected.length == 0">Remove from list</button>
                      <span class="whyDisabled">
                        <span v-if="are_selected.length < 1">Please select at least 1 startup</span>
                      </span>
                    </div>
                    <div class="zoneBtn" :class="(are_selected.length == 0) ? 'enableWhyDisabled' :'ok'">
                      <button type="button" class="action_btn" :class="(are_selected.length == 0) ? 'disabledRlink' :'ok'" name="button" @click="openModalList" :disabled="are_selected.length == 0">Add to a list</button>
                      <span class="whyDisabled">
                        <span v-if="are_selected.length < 1">Please select at least 1 startup</span>
                      </span>
                    </div>

                  </div> -->

                <!-- </div> -->
                <!-- <div class="row  p-rl-50" v-if="startups_quicksearch" >
                  <div class="col-12" style="margin-top:20px;">
                    <small><strong>Results : {{startups_quicksearch.length}} startup<span v-if="startups_quicksearch.length > 1">s</span></strong></small>

                  </div>
                </div> -->
                <!-- <div class="row flexIt p-rl-50" v-if="startups_quicksearch" >
                  <div class="col-12" style="margin-top:20px;">
                    <small><strong>Results : <span class="nuumberRes">{{startups_quicksearch.length}} startup<span v-if="startups_quicksearch.length > 1">s</span></span></strong></small>
                    <div class="mlauto" >
                      <button type="button" class="selectAll" @click="selectAll" v-if='allSelect == false' name="button">Select All</button>
                      <button type="button" class="selectAll" @click="unselectAll" v-if='allSelect == true' name="button">Unselect All</button>

                    </div>
                  </div>
                </div> -->
                <div class="row zone p-rl-50">
                  <div class="loaderInnopearl " v-if="loadingAffinity">
                    <div class="loaderInnopearlInner">
                      <img :src="require('@/assets/loaderInnopearl.svg')" alt="">
                      <span>Synchronization of selected companies in Affinity in progress.</span>
                    </div>

                  </div>
                  <div class="col-12 zone_startups" v-else>
                    <div class="row" v-if="startups_quicksearch.length > 0">
                      <div class="col-12 col-md-6 col-xl-4 candidate" v-for="(candidate, c) in startups_quicksearch" :key="c">
                        <div class="candidate_card" :class="[(are_selected.includes(candidate._id.$oid)) ? 'isChecked' : 'notChecked' , candidate.isAssess ? 'isAssess' : 'notAssess']">
                          <div class="candidate_card_head">
                            <!-- <span class="score" v-if="pool.isLongList != true"> -->
                              <!-- {{candidate.percent_score.toFixed()}} -->
                              <CircularProgress :value="candidate.percent_score.toFixed()"  v-if="pool.isLongList != true"/>
                            <!-- </span> -->
                            <span class="name">{{candidate.name}}</span>
                            <div class="goRight">
                              <!-- <div v-if="candidate.isAssess">
                                <div class="extraPoolsContainer">
                                  <img :src="require('@/assets/isAssess.svg')" class="extraPoolsIcons">
                                  <span class="hoverInfo">In assessment stage</span>
                                </div>
                              </div> -->

                              <img :src="require('@/assets/inAnAssess.svg')" @click="showCandidateAssessment(candidate)" alt="" v-if="candidate.assessments.length > 0">

                              <div v-if="candidate.extraPools > 0">
                                <div class="extraPoolsContainer">
                                  <img :src="require('@/assets/list.svg')" class="extraPoolsIcons"><span class="extraPoolsNumber">{{candidate.extraPools}}</span>
                                  <span class="hoverInfo">In {{candidate.extraPools}} other list<span v-if="candidate.extraPools > 1">s</span></span>
                                </div>
                              </div>
                              <div class="selectIt">
                                <input class="checkbox__input" type="checkbox" v-model="are_selected" :value="candidate._id.$oid"/>
                                <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                                  <rect class="fond" width="21" height="21" x=".5" y=".5" fill="none" stroke="#fff" rx="3" />
                                  <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="2" d="M4 10l5 5 9-9" />
                                </svg>
                              </div>
                            </div>

                          </div>
                          <div class="candidate_info_content">
                            <StartupCardInner v-if="candidate.company_type?.value?.toUpperCase() == 'STARTUP'" :candidate="candidate"/>
                            <NonStartupCardInner v-else :candidate="candidate"/>

                          </div>
                            <div class="website" v-if="candidate.website">
                               <a :href="getHttpsUrl(candidate.website)" target="_blank">{{ getBaseUrl(candidate.website) }}</a>
                            </div>
                          <div class="footer">
                            <div class="showComments" @click='openModal(candidate)' >
                              <img :src="require('@/assets/comments.svg')" alt="">
                              <span class="nb_item_comments">{{candidate.comments.length}}</span>
                            </div>

                            <router-link class="detail" :to="'/startup/'+candidate._id.$oid+'?sf='+sf"  v-if="candidate._id" >
                            Details
                            </router-link>
                          </div>


                              </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="alert alert-warning mt30" v-if="!loading">
                          No innovators
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt50 mb50" v-else>
                <div class="alert alert-warning text-center mt50" v-if="!loading">
                    No innovators available
                </div>
              </div>

          </div>
        </div>
        <div class="row center pad-50">
          <div class="col-12">
            <button v-if="canGoBack" class="prev_step_btn" @click="gobackrouter()">
              <img :src="require('@/assets/prev.svg')" alt="">
              GO BACK
            </button>
          </div>

        </div>

      </div>
  </div>
</template>
<script>
import api from '../tools/api';
import CircularProgress from '@/components/CircularProgress.vue';
// import { debounce } from 'lodash';
 import AddCommentModal from '@/components/modals/addCommentWithList.vue'
import StartupCardInner from '@/components/StartupCardInner.vue'
import NonStartupCardInner from '@/components/NonStartupCardInner.vue'



// import {
//   VueCollapsiblePanelGroup,
//   VueCollapsiblePanel,
// } from '@dafcoe/vue-collapsible-panel'
// import '@dafcoe/vue-collapsible-panel/dist/vue-collapsible-panel.css'
  import { toast } from 'vue-sonner'
  //import LongListUploader from '@/components/LongListUploader.vue'
  import NewFilter from '@/components/NewFilter.vue'
 import AddToListModal from '@/components/modals/addToList.vue'
 import StartupRunAssessment from '@/components/StartupRunAssessment.vue'
  import DetailAssessment from '@/components/DetailAssessment.vue'
  import countries from '@/assets/flat_countries_db.json';
  import ConfirmModal from '@/components/modals/ConfirmModal.vue';
export default {
  components: {
    // VueCollapsiblePanelGroup,
    // VueCollapsiblePanel,
    CircularProgress,
    AddCommentModal,
  //  LongListUploader,
    StartupRunAssessment,
    AddToListModal,
    StartupCardInner,
    NonStartupCardInner,
    NewFilter,
    DetailAssessment,
    ConfirmModal
  },
  name: 'StartupsStatsListSpace',
  data() {
    return {
      dialogAffinity:false,
      loadingAffinity:false,
      showAffinity: false,
      pageInfo: {
        mainTitle : "Partners’ qualifications:",
        subTitle : "Evaluate and prioritize the best options ",
      },
      toggle: false,
      quicksearch: "",
      pool: {
        name :"",
        isLongList : false,
      },
      sf: null,
      loading:false,
      minscore: 0,
      dialogRemove:false,
      dict_loaded : false,
      showConfirmDialog: false,
      showNewFilterPannel: false,
      showSidePanelBasic:false,
      runassessment:false,
      isLongList : true,
      matching_search_filtre: "",
      showMatching : false,
      allHigh : false,
      allMedium : false,
      allLow : false,
      allSelect: false,
      sfname: "",
      dialog :false,
      dialogList: false,
      startups : null,
      filtres: [],
      selected_filters: [],
      to_compare: [],
      to_assess: [],
      are_selected: [],
      isAssess:false,
      detailAssessment:false,
        detailsForCandidate:null,
      candidateForComments: null,
      // basicFilters : [
      //       {
      //           "key": "funding_stage",
      //           "values": [],
      //           "values_list" :[],
      //           "display_name" : "Funding Stage",
      //           toggled: false,
      //           toggled_sidebar: false,
      //           filtre:""
      //       },
      //       {
      //           "key": "development_stage",
      //           "values": [],
      //           "values_list" :[],
      //           "display_name" : "Development stage",
      //           toggled: false,
      //           toggled_sidebar: false,
      //           filtre:""
      //       },
      //       {
      //           "key": "business_model",
      //           "values": [],
      //           "values_list" :[],
      //           "display_name" : "Business model",
      //           toggled: false,
      //           toggled_sidebar: false,
      //           filtre:""
      //       },
      //       {
      //           "key": "IP",
      //           "values": [],
      //           "dict" : "ip",
      //           "values_list" :[],
      //           "display_name" : "IP",
      //           toggled: false,
      //           toggled_sidebar: false,
      //           filtre:""
      //       },
      //       {
      //           "key": "product_category",
      //           "values": [],
      //           "values_list" :[],
      //           "display_name" : "Innovation category",
      //           toggled: false,
      //           toggled_sidebar: false,
      //           filtre:""
      //       },
      //       {
      //           "key": "innovation_area",
      //           "dict" :"innovation_areas",
      //           "values": [],
      //           "values_list" :[],
      //           "display_name" : "Innovation area",
      //           toggled: false,
      //           toggled_sidebar: false,
      //           filtre:""
      //       },
      //       {
      //           "key": "application_area",
      //           "dict" :"application_areas",
      //           "values": [],
      //           "values_list" :[],
      //           "display_name" : "Application domain",
      //           toggled: false,
      //           toggled_sidebar: false,
      //           filtre:""
      //       },
      //       {
      //           "key": "markets",
      //           "values": [],
      //           "values_list" :[],
      //           "display_name" : "Served markets",
      //           toggled: false,
      //           toggled_sidebar: false,
      //           filtre:""
      //       },
      //       {
      //           "key": "skills",
      //           "values": [],
      //           "values_list" :[],
      //           "display_name" : "Skills",
      //           toggled: false,
      //           toggled_sidebar: false,
      //           filtre:""
      //       },
      //       {
      //           "key": "assets",
      //           "values": [],
      //           "dict" : "type_of_assets",
      //           "values_list" :[],
      //           "display_name" : "Assets",
      //           toggled: false,
      //           toggled_sidebar: false,
      //           filtre:""
      //       },
      //       {
      //           "key": "partnership_objectives",
      //           "values": [],
      //           "dict" : "partnership_objectives_startup",
      //           "values_list" :[],
      //           "display_name" : "Partnership objectives",
      //           toggled: false,
      //           toggled_sidebar: false,
      //           filtre:""
      //       },
      //       // {
      //       //     "key": "assets",
      //       //     "values": [],
      //       //     "dict" : "type_of_assets",
      //       //     "values_list" :[],
      //       //     "display_name" : "Assets",
      //       //     toggled: false,
      //       //     toggled_sidebar: false,
      //       //     filtre:""
      //       // },
      //       {
      //           "key": "sustainability_impact",
      //           "values": [],
      //           "dict" : "sustainability_impact",
      //           "values_list" :[],
      //           "display_name" : "Sustainability impact",
      //           toggled: false,
      //           toggled_sidebar: false,
      //           filtre:""
      //       },
      //       // {
      //       //     "key": "key_benefits",
      //       //     "values": [],
      //       //     "values_list" :[],
      //       //     "display_name" : "Key benefits",
      //       //     toggled: false,
      //       //     filtre:""
      //       // },
      //       {
      //         "key":"revenue",
      //         "display_name":"Revenue",
      //         "values": {
      //           "min": 0,
      //           "max" : 0,
      //           "unit": "K",
      //           "devise": "EUR"
      //         },
      //         toggled_sidebar: false,
      //       },
      //       {
      //           "key": "location",
      //           "values": [],
      //           "values_list" :[
      //               {
      //                   "value": "eu",
      //                   "name": "Europe (all)"
      //               },
      //               {
      //                   "value": "Ukraine",
      //                   "name": "Ukraine"
      //               },
      //               {
      //                   "value": "Poland",
      //                   "name": "Poland"
      //               },
      //               {
      //                   "value": "Romania",
      //                   "name": "Romania"
      //               },
      //               {
      //                   "value": "Czech Republic",
      //                   "name": "Czech Republic"
      //               },
      //               {
      //                   "value": "Hungary",
      //                   "name": "Hungary"
      //               },
      //               {
      //                   "value": "Belarus",
      //                   "name": "Belarus"
      //               },
      //               {
      //                   "value": "Bulgaria",
      //                   "name": "Bulgaria"
      //               },
      //               {
      //                   "value": "Slovakia",
      //                   "name": "Slovakia"
      //               },
      //               {
      //                   "value": "Moldova",
      //                   "name": "Moldova"
      //               },
      //               {
      //                   "value": "Russia",
      //                   "name": "Russia"
      //               },
      //               {
      //                   "value": "Western europe",
      //                   "name": "Western europe"
      //               },
      //               {
      //                   "value": "Germany",
      //                   "name": "Germany"
      //               },
      //               {
      //                   "value": "France",
      //                   "name": "France"
      //               },
      //               {
      //                   "value": "Netherlands",
      //                   "name": "Netherlands"
      //               },
      //               {
      //                   "value": "Belgium",
      //                   "name": "Belgium"
      //               },
      //               {
      //                   "value": "Austria",
      //                   "name": "Austria"
      //               },
      //               {
      //                   "value": "Switzerland",
      //                   "name": "Switzerland"
      //               },
      //               {
      //                   "value": "Luxembourg",
      //                   "name": "Luxembourg"
      //               },
      //               {
      //                   "value": "Monaco",
      //                   "name": "Monaco"
      //               },
      //               {
      //                   "value": "Liechtenstein",
      //                   "name": "Liechtenstein"
      //               },
      //               {
      //                   "value": "Southern Europe",
      //                   "name": "Southern Europe"
      //               },
      //               {
      //                   "value": "Italy",
      //                   "name": "Italy"
      //               },
      //               {
      //                   "value": "Spain",
      //                   "name": "Spain"
      //               },
      //               {
      //                   "value": "Greece",
      //                   "name": "Greece"
      //               },
      //               {
      //                   "value": "Portugal",
      //                   "name": "Portugal"
      //               },
      //               {
      //                   "value": "Serbia",
      //                   "name": "Serbia"
      //               },
      //               {
      //                   "value": "Croatia",
      //                   "name": "Croatia"
      //               },
      //               {
      //                   "value": "Bosnia and Herzegovina",
      //                   "name": "Bosnia and Herzegovina"
      //               },
      //               {
      //                   "value": "Albania",
      //                   "name": "Albania"
      //               },
      //               {
      //                   "value": "North Macedonia",
      //                   "name": "North Macedonia"
      //               },
      //               {
      //                   "value": "Slovenia",
      //                   "name": "Slovenia"
      //               },
      //               {
      //                   "value": "Montenegro",
      //                   "name": "Montenegro"
      //               },
      //               {
      //                   "value": "Malta",
      //                   "name": "Malta"
      //               },
      //               {
      //                   "value": "Andorra",
      //                   "name": "Andorra"
      //               },
      //               {
      //                   "value": "San Marino",
      //                   "name": "San Marino"
      //               },
      //               {
      //                   "value": "Nothern Europe",
      //                   "name": "Nothern Europe"
      //               },
      //               {
      //                   "value": "United Kingdom",
      //                   "name": "United Kingdom"
      //               },
      //               {
      //                   "value": "Sweden",
      //                   "name": "Sweden"
      //               },
      //               {
      //                   "value": "Denmark",
      //                   "name": "Denmark"
      //               },
      //               {
      //                   "value": "Finland",
      //                   "name": "Finland"
      //               },
      //               {
      //                   "value": "Norway",
      //                   "name": "Norway"
      //               },
      //               {
      //                   "value": "Ireland",
      //                   "name": "Ireland"
      //               },
      //               {
      //                   "value": "Lithuania",
      //                   "name": "Lithuania"
      //               },
      //               {
      //                   "value": "Latvia",
      //                   "name": "Latvia"
      //               },
      //               {
      //                   "value": "Estonia",
      //                   "name": "Estonia"
      //               },
      //               {
      //                   "value": "Iceland",
      //                   "name": "Iceland"
      //               },
      //               {
      //                   "value": "Asia",
      //                   "name": "Asia"
      //               },
      //               {
      //                   "value": "Northern Asia",
      //                   "name": "Northern Asia"
      //               },
      //               {
      //                   "value": "Russia (asia)",
      //                   "name": "Russia (Asia)"
      //               },
      //               {
      //                   "value": "Western Asia",
      //                   "name": " Western Asia"
      //               },
      //               {
      //                   "value": "Armenia",
      //                   "name": "Armenia"
      //               },
      //               {
      //                   "value": "Azerbaijan",
      //                   "name": "Azerbaijan"
      //               },
      //               {
      //                   "value": "Bahrain",
      //                   "name": "Bahrain"
      //               },
      //               {
      //                   "value": "Cyprus",
      //                   "name": "Cyprus"
      //               },
      //               {
      //                   "value": "Georgia",
      //                   "name": "Georgia"
      //               },
      //               {
      //                   "value": "Iran",
      //                   "name": "Iran"
      //               },
      //               {
      //                   "value": "Iraq",
      //                   "name": "Iraq"
      //               },
      //               {
      //                   "value": "Israel",
      //                   "name": "Israel"
      //               },
      //               {
      //                   "value": "Jordan",
      //                   "name": "Jordan"
      //               },
      //               {
      //                   "value": "Kuwait",
      //                   "name": "Kuwait"
      //               },
      //               {
      //                   "value": "Lebanon",
      //                   "name": "Labanon"
      //               },
      //               {
      //                   "value": "Oman",
      //                   "name": "Oman"
      //               },
      //               {
      //                   "value": "Qatar",
      //                   "name": "Qatar"
      //               },
      //               {
      //                   "value": "Saudi Arabia",
      //                   "name": "Saudi Arabia"
      //               },
      //               {
      //                   "value": "State of Palestine",
      //                   "name": "State of Palestine"
      //               },
      //               {
      //                   "value": "Syria",
      //                   "name": "Syria"
      //               },
      //               {
      //                   "value": "Turkey",
      //                   "name": "Turkey"
      //               },
      //               {
      //                   "value": "United Aradb Emirates",
      //                   "name": "United Arab Emirates"
      //               },
      //               {
      //                   "value": "Central Asia",
      //                   "name": "Central Asia"
      //               },
      //               {
      //                   "value": "Afghanistan",
      //                   "name": "Afghanistan"
      //               },
      //               {
      //                   "value": "Kazakhstan",
      //                   "name": "Kazahstan"
      //               },
      //               {
      //                   "value": "Kyrgyzstan",
      //                   "name": "Kyrgyzstan"
      //               },
      //               {
      //                   "value": "Tajikistan",
      //                   "name": "Tajikistan"
      //               },
      //               {
      //                   "value": "Turkmenistan",
      //                   "name": "Turkmenistan"
      //               },
      //               {
      //                   "value": "Uzbekistan",
      //                   "name": "Uzbekistan"
      //               },
      //               {
      //                   "value": "East Asia",
      //                   "name": "East Asia"
      //               },
      //               {
      //                   "value": "China",
      //                   "name": "China"
      //               },
      //               {
      //                   "value": "China, Hong Kong SAR",
      //                   "name": "China, Hong Kong SAR"
      //               },
      //               {
      //                   "value": "China, Macao SAR",
      //                   "name": "China, Macao SAR"
      //               },
      //               {
      //                   "value": "Japan",
      //                   "name": "Japan"
      //               },
      //               {
      //                   "value": "Korea (North)",
      //                   "name": "Korea (North)"
      //               },
      //               {
      //                   "value": "Korea (South)",
      //                   "name": "Korea (South)"
      //               },
      //               {
      //                   "value": "Mongolia",
      //                   "name": "Mongolia"
      //               },
      //               {
      //                   "value": "Taiwan",
      //                   "name": "Taiwan"
      //               },
      //               {
      //                   "value": "South Asia",
      //                   "name": "South Asia"
      //               },
      //               {
      //                   "value": "Bangladesh",
      //                   "name": "Bangladesh"
      //               },
      //               {
      //                   "value": "Bhutan",
      //                   "name": "Bhutan"
      //               },
      //               {
      //                   "value": "India",
      //                   "name": "India"
      //               },
      //               {
      //                   "value": "Maldives",
      //                   "name": "Maldives"
      //               },
      //               {
      //                   "value": "Nepal",
      //                   "name": "Nepal"
      //               },
      //               {
      //                   "value": "Pakistan",
      //                   "name": "Pakistan"
      //               },
      //               {
      //                   "value": "Sri Lanka",
      //                   "name": "Sri Lanla"
      //               },
      //               {
      //                   "value": "Southeast Asia",
      //                   "name": "Southeast Asia"
      //               },
      //               {
      //                   "value": "Brunei Darussalam",
      //                   "name": "Brunei Darussalam"
      //               },
      //               {
      //                   "value": "Cambodia",
      //                   "name": "Cambodia"
      //               },
      //               {
      //                   "value": "Indonesia",
      //                   "name": "Indonesia"
      //               },
      //               {
      //                   "value": "Lao PDR",
      //                   "name": "Lao PDR"
      //               },
      //               {
      //                   "value": "Malaysia",
      //                   "name": "Malaysia"
      //               },
      //               {
      //                   "value": "Myanmar (Burma)",
      //                   "name": "Myanmar (Burma)"
      //               },
      //               {
      //                   "value": "Philippines",
      //                   "name": "Philippines"
      //               },
      //               {
      //                   "value": "Singapore",
      //                   "name": "Singapore"
      //               },
      //               {
      //                   "value": "Thailand",
      //                   "name": "Thailand"
      //               },
      //               {
      //                   "value": "Timor-Leste",
      //                   "name": "Timor-Leste"
      //               },
      //               {
      //                   "value": "Vietnam",
      //                   "name": "Vietnam"
      //               },
      //               {
      //                   "value": "Africa (all)",
      //                   "name": "Africa (all)"
      //               },
      //               {
      //                   "value": "North Africa",
      //                   "name": "North Africa"
      //               },
      //               {
      //                   "value": "Algeria",
      //                   "name": "Algeria"
      //               },
      //               {
      //                   "value": "Egypt",
      //                   "name": "Egypt"
      //               },
      //               {
      //                   "value": "Libya",
      //                   "name": "Libya"
      //               },
      //               {
      //                   "value": "Marocco",
      //                   "name": "Marocco"
      //               },
      //               {
      //                   "value": "Sudan",
      //                   "name": "Sudan"
      //               },
      //               {
      //                   "value": "Tunisia",
      //                   "name": "Tunisia"
      //               },
      //               {
      //                   "value": "West Africa",
      //                   "name": "West Africa"
      //               },
      //               {
      //                   "value": "Benin",
      //                   "name": "Benin"
      //               },
      //               {
      //                   "value": "Burkina Fasso",
      //                   "name": "Burkina Fasso"
      //               },
      //               {
      //                   "value": "Cape Verde",
      //                   "name": "Cape Verde"
      //               },
      //               {
      //                   "value": "Ivory Coast",
      //                   "name": "Ivoy Coast"
      //               },
      //               {
      //                   "value": "Gambia",
      //                   "name": "Gambia"
      //               },
      //               {
      //                   "value": "Ghana",
      //                   "name": "Ghana"
      //               },
      //               {
      //                   "value": "Guinea",
      //                   "name": "Guinea"
      //               },
      //               {
      //                   "value": "Guinea-Bissau",
      //                   "name": "Guinea-Bissau"
      //               },
      //               {
      //                   "value": "Liberia",
      //                   "name": "Liberia"
      //               },
      //               {
      //                   "value": "Mali",
      //                   "name": "Mali"
      //               },
      //               {
      //                   "value": "Mauritania",
      //                   "name": "Mauritania"
      //               },
      //               {
      //                   "value": "Niger",
      //                   "name": "Niger"
      //               },
      //               {
      //                   "value": "Nigeria",
      //                   "name": "Nigeria"
      //               },
      //               {
      //                   "value": "Saint Helena",
      //                   "name": "Saint Helena (UK)"
      //               },
      //               {
      //                   "value": "Senegal",
      //                   "name": "Senegal"
      //               },
      //               {
      //                   "value": "Sierra Leone",
      //                   "name": "Sierra Leone"
      //               },
      //               {
      //                   "value": "Togo",
      //                   "name": "Togo"
      //               },
      //               {
      //                   "value": "East Africa",
      //                   "name": "East Africa"
      //               },
      //               {
      //                   "value": "Burundi",
      //                   "name": "Burundi"
      //               },
      //               {
      //                   "value": "Comoros",
      //                   "name": "Comoros"
      //               },
      //               {
      //                   "value": "Djibouti",
      //                   "name": "Djibouti"
      //               },
      //               {
      //                   "value": "Eritrea",
      //                   "name": "Eritrea"
      //               },
      //               {
      //                   "value": "Ethiopia",
      //                   "name": "Ethiopia"
      //               },
      //               {
      //                   "value": "Kenya",
      //                   "name": "Kenya"
      //               },
      //               {
      //                   "value": "Madagascar",
      //                   "name": "Madagascar"
      //               },
      //               {
      //                   "value": "Malawi",
      //                   "name": "Malawi"
      //               },
      //               {
      //                   "value": "Mauritius",
      //                   "name": "Mauritius"
      //               },
      //               {
      //                   "value": "Mozambique",
      //                   "name": "Mozambique"
      //               },
      //               {
      //                   "value": "Réunion (France)",
      //                   "name": "Réunion (France)"
      //               },
      //               {
      //                   "value": "Rwanda",
      //                   "name": "Rwanda"
      //               },
      //               {
      //                   "value": "Seychelles",
      //                   "name": "Seychelles"
      //               },
      //               {
      //                   "value": "Somalia",
      //                   "name": "Somalia"
      //               },
      //               {
      //                   "value": "South Sudan",
      //                   "name": "South Sudan"
      //               },
      //               {
      //                   "value": "Tanzania",
      //                   "name": "Tanzania"
      //               },
      //               {
      //                   "value": "Uganda",
      //                   "name": "Uganda"
      //               },
      //               {
      //                   "value": "Zambia",
      //                   "name": "Zambia"
      //               },
      //               {
      //                   "value": "Zimbabwe",
      //                   "name": "Zimbabwe"
      //               },
      //               {
      //                   "value": "Southern Africa",
      //                   "name": "Southern Africa"
      //               },
      //               {
      //                   "value": "Bostwana",
      //                   "name": "Bostwana"
      //               },
      //               {
      //                   "value": "Lesotho",
      //                   "name": "Lesotho"
      //               },
      //               {
      //                   "value": "Namibia",
      //                   "name": "Namibia"
      //               },
      //               {
      //                   "value": "South Africa",
      //                   "name": "South Africa"
      //               },
      //               {
      //                   "value": "Swaziland",
      //                   "name": "Swaziland"
      //               },
      //               {
      //                   "value": "America",
      //                   "name": "America"
      //               },
      //               {
      //                   "value": "North America",
      //                   "name": "North America"
      //               },
      //               {
      //                   "value": "Canada",
      //                   "name": "Canada"
      //               },
      //               {
      //                   "value": "Greenland",
      //                   "name": "Greenland (Denmark)"
      //               },
      //               {
      //                   "value": "Mexico",
      //                   "name": "Mexico"
      //               },
      //               {
      //                   "value": "USA",
      //                   "name": "USA"
      //               },
      //               {
      //                   "value": "The Carribean",
      //                   "name": "The Carribean"
      //               },
      //               {
      //                   "value": "Anguilla (UK)",
      //                   "name": "Anguilla (UK)"
      //               },
      //               {
      //                   "value": "Antigua and Barbuda",
      //                   "name": "Antigua and Barbuda"
      //               },
      //               {
      //                   "value": "Aruba (NL)",
      //                   "name": "Aruba (NL)"
      //               },
      //               {
      //                   "value": "Bahamas",
      //                   "name": "Bahamas"
      //               },
      //               {
      //                   "value": "Barbados",
      //                   "name": "Barbados"
      //               },
      //               {
      //                   "value": "Bermuda (UK)",
      //                   "name": "Bermdua (UK)"
      //               },
      //               {
      //                   "value": "British Virgin Island",
      //                   "name": "British Virgin Island"
      //               },
      //               {
      //                   "value": "Cayman Island",
      //                   "name": "Cayman Island"
      //               },
      //               {
      //                   "value": "Cuba",
      //                   "name": "Cuba"
      //               },
      //               {
      //                   "value": "Curaçao",
      //                   "name": "Curaçao"
      //               },
      //               {
      //                   "value": "Dominica",
      //                   "name": "Dominica"
      //               },
      //               {
      //                   "value": "Dominican Republic",
      //                   "name": "Dominican Republic"
      //               },
      //               {
      //                   "value": "Granada",
      //                   "name": "Granada"
      //               },
      //               {
      //                   "value": "Guadeloupe (FR)",
      //                   "name": "Guadeloupe (FR)"
      //               },
      //               {
      //                   "value": "Haiti",
      //                   "name": "Haiti"
      //               },
      //               {
      //                   "value": "Jamaica",
      //                   "name": "Jamaica"
      //               },
      //               {
      //                   "value": "Martinique (FR)",
      //                   "name": "Martinique (FR)"
      //               },
      //               {
      //                   "value": "Montserrat (UK)",
      //                   "name": "Montserrat (UK)"
      //               },
      //               {
      //                   "value": "Puerto Ricco (USA)",
      //                   "name": "Puerto Ricco (USA)"
      //               },
      //               {
      //                   "value": "Saint Kitts and Nevis",
      //                   "name": "Saint Kitts and Nevis"
      //               },
      //               {
      //                   "value": "Saint Lucia",
      //                   "name": "Saint Lucia"
      //               },
      //               {
      //                   "value": "Saint Vincent and the Grenadines",
      //                   "name": "Saint Vincent and the Grenadines"
      //               },
      //               {
      //                   "value": "Trinidad and Tobago",
      //                   "name": "Trinidad and Tobago"
      //               },
      //               {
      //                   "value": "US Virgin Island",
      //                   "name": "US Virgin Island"
      //               },
      //               {
      //                   "value": "Central America",
      //                   "name": "Central America"
      //               },
      //               {
      //                   "value": "Belize",
      //                   "name": "Belize"
      //               },
      //               {
      //                   "value": "Costa Rica",
      //                   "name": "Costa Rica"
      //               },
      //               {
      //                   "value": "El Salvador",
      //                   "name": "El Salvador"
      //               },
      //               {
      //                   "value": "Guatemala",
      //                   "name": "Guatemala"
      //               },
      //               {
      //                   "value": "Honduras",
      //                   "name": "Honduras"
      //               },
      //               {
      //                   "value": "Nicaragua",
      //                   "name": "Nicaragua"
      //               },
      //               {
      //                   "value": "Panama",
      //                   "name": "Panama"
      //               },
      //               {
      //                   "value": "South America",
      //                   "name": "South America"
      //               },
      //               {
      //                   "value": "Argentina",
      //                   "name": "Argentina"
      //               },
      //               {
      //                   "value": "Bolivia",
      //                   "name": "Bolivia"
      //               },
      //               {
      //                   "value": "Brazil",
      //                   "name": "Brazil"
      //               },
      //               {
      //                   "value": "Chile",
      //                   "name": "Chile"
      //               },
      //               {
      //                   "value": "Colombia",
      //                   "name": "Colombia"
      //               },
      //               {
      //                   "value": "Ecuador",
      //                   "name": "Ecuador"
      //               },
      //               {
      //                   "value": "French Guiana (FR)",
      //                   "name": "French Guiana (FR)"
      //               },
      //               {
      //                   "value": "Guyana",
      //                   "name": "Guyana"
      //               },
      //               {
      //                   "value": "Paraguay",
      //                   "name": "Paraguay"
      //               },
      //               {
      //                   "value": "Peru",
      //                   "name": "Peru"
      //               },
      //               {
      //                   "value": "Suriname",
      //                   "name": "Suriname"
      //               },
      //               {
      //                   "value": "Uruguay",
      //                   "name": "Uruguay"
      //               },
      //               {
      //                   "value": "Veneuzela",
      //                   "name": "Venezuela"
      //               },
      //               {
      //                   "value": "Australia",
      //                   "name": "Australia"
      //               },
      //               {
      //                   "value": "Oceania",
      //                   "name": "Oceania"
      //               },
      //               {
      //                   "value": "New Zeland",
      //                   "name": "New Zeland"
      //               }
      //           ],
      //           "display_name" : "Location",
      //           toggled: false,
      //           toggled_sidebar: false,
      //           filtre:""
      //       }
      //   ]
      basicFilters: [
    {
        "key": "application_area",
        "dict": "application_areas",
        "values": [],
        "values_list": [],
        "display_name": "Application domain",
        "toggled": false,
        "toggled_sidebar": false,
        "filtre": ""
    },
    {
        "key": "assets",
        "values": [],
        "dict": "type_of_assets",
        "values_list": [],
        "display_name": "Assets",
        "toggled": false,
        "toggled_sidebar": false,
        "filtre": ""
    },
    {
        "key": "business_model",
        "values": [],
        "values_list": [],
        "display_name": "Business model",
        "toggled": false,
        "toggled_sidebar": false,
        "filtre": ""
    },
    {
        "key": "company_type",
        "dict": "company_type",
        "values": [],
        "values_list": [],
        "display_name": "Company type",
        toggled: false,
        toggled_sidebar: false,
        filtre: ""
    },
    {
        "key": "data_available",
        "dict": "data_available",
        "values": [],
        "values_list": [],
        "display_name": "Data available",
        toggled: false,
        toggled_sidebar: false,
        filtre:""
    },
    {
        "key": "development_stage",
        "values": [],
        "values_list": [],
        "display_name": "Development stage",
        "toggled": false,
        "toggled_sidebar": false,
        "filtre": ""
    },
    {
        "key": "funding_stage",
        "values": [],
        "values_list": [],
        "display_name": "Funding Stage",
        "toggled": false,
        "toggled_sidebar": false,
        "filtre": ""
    },
    {
        "key": "IP",
        "values": [],
        "dict": "ip",
        "values_list": [],
        "display_name": "IP",
        "toggled": false,
        "toggled_sidebar": false,
        "filtre": ""
    },
    {
        "key": "innovation_area",
        "dict": "innovation_areas",
        "values": [],
        "values_list": [],
        "display_name": "Innovation area",
        "toggled": false,
        "toggled_sidebar": false,
        "filtre": ""
    },
    {
        "key": "product_category",
        "values": [],
        "values_list": [],
        "display_name": "Innovation category",
        "toggled": false,
        "toggled_sidebar": false,
        "filtre": ""
    },
    {
        "key": "linkplus",
        "values": [],
        "values_list": [],
        "display_name": "Link+",
        "toggled": false,
        "toggled_sidebar": false,
        "filtre": ""
    },
    {
        "key": "location",
        "values": [],
        "values_list": countries,
        "display_name": "Location",
        "toggled": false,
        "toggled_sidebar": false,
        "filtre": ""
    },
    {
        "key": "markets",
        "values": [],
        "values_list": [],
        "display_name": "Served markets",
        "toggled": false,
        "toggled_sidebar": false,
        "filtre": ""
    },
    {
        "key": "partnership_objectives",
        "values": [],
        "dict": "partnership_objectives",
        "values_list": [],
        "display_name": "Partnership objectives",
        "toggled": false,
        "toggled_sidebar": false,
        "filtre": ""
    },
    {
        "key": "revenue",
        "display_name": "Revenue",
        "values": {
            "min": 0,
            "max": 0,
            "unit": "M",
            "devise": "EUR"
        },
        "toggled_sidebar": false
    },
    {
        "key": "skills",
        "values": [],
        "values_list": [],
        "display_name": "Skills",
        "toggled": false,
        "toggled_sidebar": false,
        "filtre": ""
    },
    {
        "key": "sustainability_impact",
        "values": [],
        "dict": "sustainability_impact",
        "values_list": [],
        "display_name": "Sustainability impact",
        "toggled": false,
        "toggled_sidebar": false,
        "filtre": ""
    }
]


    }
  },
  computed: {
    canGoBack() {
      // console.log("router");
      // console.log(this.$router.currentRoute.matched);
      // console.log(window.history);
      //return this.$router.history.length > 1;
      if(window.history)
        if(window.history.length > 1)return true;
      return false;

    }
  },
  methods:{
    sendAffinity(){
      if(this.$store.state.affinityConfig){
        this.loadingAffinity = true;
        api.post(process.env.VUE_APP_API_URL+"/restrict/sync_startup_affinity",
            {
              candidates : this.are_selected,
              affinityConfig : this.$store.state.affinityConfig
            },
            {
              headers: {
                  'Content-Type': 'application/json',
            }
          }).then( (r) => {
            console.log(r);
            this.loadingAffinity = false;
            toast.success("Selected companies have been synchronized in Affinity ");
          }).catch( (e) => {
            if(e.response.data.undone){
              e.response.data.undone.forEach((item) => {
                  toast.error("Impossible to add "+item.name+" on Affinity",{description:"Reason : "+item.reason,duration:10000});
              });
            }
            else{
              if(e.response.data.message){
                  toast.error(e.response.data.message,{duration:10000});
              }
              else toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

            }
            this.loadingAffinity = false;
          });
        }
        else{
          toast.error("Your affinity connection informations are not set or incorrect. Please contact us to fix them.");
          this.loadingAffinity = false;
        }
        this.dialogAffinity = false;
    },
    removeStartup(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/remove_startup_from_pool",
            {
              candidates : this.are_selected,
              pool : this.$route.params.pool
            },
            {
              headers: {
                  'Content-Type': 'application/json',
            }
          }).then( () => {
            toast.success("Startups successfully removed from your innovator pool.");
            this.apply_filter();
          }).catch( () => {
              toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
      }

        this.dialogRemove =false;
    },
    showCandidateAssessment(c){
      this.detailsForCandidate = c;
      this.detailAssessment = true;
    },
    getBaseUrl(url){
      var formated = url.replace(/^https?:\/\//, '').replace(/\/$/, '');
      try{
        var r= new URL(url).origin;
        r = r.replace(/^https?:\/\//, '').replace(/\/$/, '');
        return r;
      }catch{
        return formated;
      }
    },
    getHttpsUrl(url){
      var f = url;
      if (!url.startsWith("https://")  && !url.startsWith("htts://") ) {
                  f = "https://" + url;
              }
              return f;
    },
    closeConfirmDialog(){
      this.showConfirmDialog = false;
    },

    showCreateFilter(){
      this.showMatching = false;
      this.showNewFilterPannel = true;
    },
    refreshFilters(d){
      console.log("TOTO",d);
      this.showNewFilterPannel = false;
      // api.get(process.env.VUE_APP_API_URL+"/restrict/my_filters").then( (r) =>{
      //   this.filtres = r.data;
      // });
      if(d){
        this.filtres.push(d);
        this.selected_filters.push(d._id.$oid);
        this.apply_filter();
      }

    },
    scorer(v){
      console.log("VVVVVVV",v);
      console.log(this.minscore);
      this.apply_filter();
    },
    reset_bfilter(){
      this.basicFilters.forEach((item) => {
        if(item.key != "revenue"){
          item.values = [];
        }
        else{
          item.values = {
            "min": 0,
            "max" : 0,
            "unit": "M",
            "devise": "EUR"
          };
        }

      });
      this.apply_filter();
    },
    toggleFilter(fk){
      console.log(fk);
      this.basicFilters = this.basicFilters.map(obj => ({
        ...obj,
        toggled: (obj.key == fk )? !obj.toggled : false
      }));
      console.log(this.basicFilters);
    },
    setLongList(){
      this.dialogFullSetFile = false;
      this.apply_filter();
    },
    apply_filter(){
      this.loading =true;
      console.log("tfdoiqsfdu ",this.basicFilters);
      // api.post(process.env.VUE_APP_API_URL+"/test_filter_multiple",
      //     {
      //         fids: this.selected_filters,
      //         search_field: this.$route.params.search_field
      //     },
      //     {
      //       headers: {
      //           'Content-Type': 'application/json',
      //     }
      //   }).then( (r) => {
      //   console.log(r.data);
      //   this.startups = r.data;
      // });
      this.basicFilters = this.basicFilters.map(obj => ({
        ...obj,
        toggled: false,
        toggled_sidebar: false
      }));
      this.showMatching = false;
      this.showSidePanelBasic = false;
      console.log("BASIC FILTER",this.basicFilters);
        console.log("fids FILTER",this.selected_filters);
      api.post(process.env.VUE_APP_API_URL+"/restrict/basic_filter_from_pool",
          {
              fids: this.selected_filters,
               search_field: this.$route.params.search_field,
              basicFilters : this.basicFilters,
              pool : this.$route.params.pool,
                     minscore : this.minscore
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
        console.log("POOLFILTERED",r.data);
        this.startups = r.data;
        this.startups_quicksearch = r.data;
        this.quicksearch = "";
        api.get(process.env.VUE_APP_API_URL+"/search_field/isAssess/"+this.$route.params.search_field).then( (r) => {
          console.log("IS ASSESS");
          console.log(r.data);
          this.isAssess = r.data.isAssess;
          this.sfname = r.data.name;
          this.loading =false;
        }).catch( (e) => {console.log(e)});
      }).catch( (e) => {console.log(e)});
    },
    openModal(candidate){
      this.candidateForComments = candidate;
      this.candidateForComments.assigned_pool = candidate.pool;
      this.dialog = true;
    },
    openModalList(){
      this.dialogList = true;
    },
    closeModal(){
      this.candidateForComments = null;

      this.dialog = false;
    },
    closeModalList(){
      this.dialogList = false;
    },

    newInternal(v){
      console.log("newInternal",v);
      var toPost = {
        assessment : v,
        startups : this.are_selected
      }
      api.post(process.env.VUE_APP_API_URL+"/restrict/createAssessmentFromPool",toPost,
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success(this.$t("Innovators are included in the assessment"));
          this.runassessment = false;
      }).catch( (e) => {
        console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

        this.runassessment = false;
      });
    },
    newInnopearl(v){
      console.log(v);
      v.startups = this.are_selected;
      api.post(process.env.VUE_APP_API_URL+"/restrict/new_innopearl_assessment",v,
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r.data);
          toast.success("Your project and selected innovators have been successfully shared with Innopearl. We’ll reach out to review the details, but you can get ahead by booking a meeting now via the Ask Us button in the navigation panel.");
              this.runassessment = false;
        }).catch( (e) => {
          console.log(e);
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });

    },
    existingInternal(v){
    console.log("existingInternal",v);
    var toPost = {
    assessment : v,
    startups : this.are_selected
    }
    api.post(process.env.VUE_APP_API_URL+"/restrict/addMultipleStartupsToAssessment",toPost,
      {
        headers: {
            'Content-Type': 'application/json',
      }
    }).then( (r) => {
      console.log(r);
      toast.success(this.$t("Innovators are included in the assessment"));
      this.runassessment = false;
    }).catch( (e) => {
    console.log(e);
      toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

    this.runassessment = false;
    });
    },
    toExisting(v){
      console.log(v);
      console.log("ARE SELECTED",this.are_selected);
      api.post(process.env.VUE_APP_API_URL+"/restrict/add_startup_to_list",
          {
            poolid : v,
            candidates : this.are_selected,
            searchfield : this.sf
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log("TO EXISTING LIST",r);
          this.apply_filter();
          toast.success("Innovators successfully added to list");
        }).catch( () => {
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
      this.dialogList = false;
    },
    removeFromList(){
      api.post(process.env.VUE_APP_API_URL+"/restrict/remove_from_list",
          {
            poolid:  this.$route.params.pool,
            candidates : this.are_selected,
            searchfield : this.sf
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log("TO NEW LIST",r);
          this.are_selected = [];
          this.apply_filter();
          toast.success("Candidates successfully removed from current list");
        }).catch( () => {
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
    },
    toNewList(v){
      console.log(v);
      api.post(process.env.VUE_APP_API_URL+"/restrict/create_new_list",
          {
            pool_name : v,
            candidates : this.are_selected,
            searchfield : this.sf
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log("TO NEW LIST",r);
          this.apply_filter();
          toast.success("List successfully created with selected candidates");
        }).catch( () => {
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
      this.dialogList = false;
    },
    setNewValueComment(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/candidate/add_comment",
        {
          comment : v,
          candidate : this.candidateForComments,
        },
        {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r);
        toast.success("Your comment is added");
          this.candidateForComments.comments.push(r.data);
          this.candidateForComments = null;
      }).catch( () => {
          this.candidateForComments = null;
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });

      }

      this.dialog = false;
    },
    selectAll(){
      this.startups.forEach((item) => {
        this.are_selected.push(item._id.$oid);
      });
      this.allSelect = true;
    },
    unselectAll(){
      this.are_selected = [];
      this.allSelect = false;
    },
    // unselectAll(niveau){
    //   console.log(niveau);
    //   if(niveau == "high"){
    //     this.startups.high.forEach((s) => {
    //         if(!s.isAssess){
    //           // if(!this.to_assess.contains(s)){
    //           //   this.to_assess.push(s);
    //           // }
    //           const isFound = this.to_assess.some(element => {
    //             if (element == s) {
    //               return true;
    //             }
    //
    //             return false;
    //           });
    //           if(isFound){
    //             const index = this.to_assess.indexOf(s);
    //             this.to_assess.splice(index,1);
    //           }
    //         }
    //     });
    //     this.allHigh = false;
    //   }
    //   if(niveau == "medium"){
    //     this.startups.medium.forEach((s) => {
    //         if(!s.isAssess){
    //           // if(!this.to_assess.contains(s)){
    //           //   this.to_assess.push(s);
    //           // }
    //           const isFound = this.to_assess.some(element => {
    //             if (element == s) {
    //               return true;
    //             }
    //
    //             return false;
    //           });
    //           if(isFound){
    //             const index = this.to_assess.indexOf(s);
    //             this.to_assess.splice(index,1);
    //           }
    //         }
    //     });
    //     this.allMedium = false;
    //   }
    //   if(niveau == "low"){
    //     this.startups.low.forEach((s) => {
    //         if(!s.isAssess){
    //           // if(!this.to_assess.contains(s)){
    //           //   this.to_assess.push(s);
    //           // }
    //           const isFound = this.to_assess.some(element => {
    //             if (element == s) {
    //               return true;
    //             }
    //
    //             return false;
    //           });
    //           if(isFound){
    //             const index = this.to_assess.indexOf(s);
    //             this.to_assess.splice(index,1);
    //           }
    //         }
    //     });
    //     this.allLow = false;
    //   }
    // },
    // selectAll(niveau){
    //   console.log(niveau);
    //   if(niveau == "high"){
    //     this.startups.high.forEach((s) => {
    //         if(!s.isAssess){
    //           // if(!this.to_assess.contains(s)){
    //           //   this.to_assess.push(s);
    //           // }
    //           const isFound = this.to_assess.some(element => {
    //             if (element == s) {
    //               return true;
    //             }
    //
    //             return false;
    //           });
    //           if(!isFound)this.to_assess.push(s);
    //         }
    //     });
    //     this.allHigh = true;
    //   }
    //   else if(niveau == "medium"){
    //     this.startups.medium.forEach((s) => {
    //         if(!s.isAssess){
    //           // if(!this.to_assess.contains(s)){
    //           //   this.to_assess.push(s);
    //           // }
    //           const isFound = this.to_assess.some(element => {
    //             if (element == s) {
    //               return true;
    //             }
    //
    //             return false;
    //           });
    //           if(!isFound)this.to_assess.push(s);
    //         }
    //     });
    //       this.allMedium = true;
    //   }
    //   else if(niveau == "low"){
    //     this.startups.low.forEach((s) => {
    //         if(!s.isAssess){
    //           // if(!this.to_assess.contains(s)){
    //           //   this.to_assess.push(s);
    //           // }
    //           const isFound = this.to_assess.some(element => {
    //             if (element == s) {
    //               return true;
    //             }
    //
    //             return false;
    //           });
    //           if(!isFound)this.to_assess.push(s);
    //         }
    //     });
    //       this.allLow = true;
    //   }
    //
    // },
    gobackrouter : function(){
      this.$router.go(-1);
    },
    generateAssessment(){
      console.log("Are selected",this.are_selected);
      var to_assess = [];
      console.log("innovators",this.startups);

      this.are_selected.forEach(selectedId => {
    // Find the corresponding element in this_startups based on _id.$oid
          let correspondingElement = this.startups.find(startupElement => startupElement._id.$oid === selectedId);

          // Check if the corresponding element is found and isAssess is not true
          if (correspondingElement && !correspondingElement.isAssess) {
              // Add the selected element to to_assess
              to_assess.push(correspondingElement);
          }
      });
      console.log(to_assess);
      ///restrict/search_field/generate_new_assessment/{searchfield}

      if(to_assess.length > 0){
        api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/generate_new_assessment/"+this.sf,
            {
                candidates: to_assess
            },
            {
              headers: {
                  'Content-Type': 'application/json',
            }
          }).then( (r) => {
            console.log(r.data);
            toast.success("New assessment have been asked to Innopearl Team");
            this.apply_filter();
          }).catch( (e) => {
            console.log(e);
              toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
      }
      else{
        toast.error("All the selected innovators are already in the assessment stage");

      }

    }
  },
  mounted(){
    this.loading =true;
    this.sf = this.$route.params.search_field;
    this.dict_loaded = false;
    this.showAffinity = (this.$store.state.affinityConfig == null || this.$store.state.affinityConfig == 'null') ? false :true;

    // if(localStorage.getItem('currentFilterSet')){
    //   var fromCookie = JSON.parse(localStorage.getItem('currentFilterSet'));
    //   this.selected_filters = fromCookie;
    // }
    var requestarray = this.basicFilters.filter(obj => ['revenue', 'location'].every(key => obj.key !== key));

    requestarray.forEach((item, index) => {

      var dict_key = (item.dict) ? item.dict : item.key;
      if(dict_key != 'location' && dict_key != "revenue" && dict_key != "submitDate" && dict_key != "linkplus" && dict_key != "submitDate"){
        api.get(process.env.VUE_APP_API_URL+"/restrict/dict/dict_"+dict_key,{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r.data);
          item.values_list = r.data;
          if(index == requestarray.length - 1){
            console.log("Dict loaded");

          }

        }).catch( error => {
          if(error.response.data.message) toast.error(error.response.data.message);
          else toast.error("Sorry, an error occurs. Please try again !");
        })
      }

        if(dict_key == "linkplus"){
          console.log("MOUNTED LP");
          api.get(process.env.VUE_APP_API_URL+"/restrict/list_mylinkplus").then( (r) => {
            // var b = _.merge(this.project.business_challenge, JSON.parse(r.data.business_challenge))
            // console.log();
            // var temp = _.merge(this.candidatespool, r.data)
            item.values_list = r.data;

      console.log("MOUNTED LP REP");
          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
        }
            this.linkplus_loaded = true;

    this.dict_loaded = true;

    });

    api.get(process.env.VUE_APP_API_URL+"/restrict/pool_info/"+this.$route.params.pool).then( (r) => {
      console.log(r.data);
      this.pool = r.data;

      if(this.pool.isLongList){
          console.log("TRY SET DICT",localStorage.getItem('currentBasicFilterSet'));
        if(localStorage.getItem('currentBasicFilterSet')){
          var fromCookie_2 = JSON.parse(localStorage.getItem('currentBasicFilterSet'));

          let updatedArrayA = this.basicFilters.map(objA => {
            let matchingObjB = fromCookie_2.find(objB => objB.key === objA.key);

            if (matchingObjB && matchingObjB["values"]) {
              objA.values = matchingObjB["values"];
            }

            return objA;
          });
          this.basicFilters = updatedArrayA;
                this.dict_loaded = true;
          console.log("set filter",this.basicFilters);
        }
      }
      else{
        if(localStorage.getItem('currentFilterSet')){

          var fromCookie = JSON.parse(localStorage.getItem('currentFilterSet'));

          this.selected_filters = fromCookie;
        }

      }



     api.get(process.env.VUE_APP_API_URL+"/restrict/my_filters").then( (r) =>{
       this.filtres = r.data;
       console.log("filtres",this.filtres);
       console.log(this.selected_filters);
       console.log(this.$route.params.pool);
       console.log(this.basicFilters);
       console.log(this.$route.params.search_field);
       console.log(this.minscore);
       api.post(process.env.VUE_APP_API_URL+"/restrict/basic_filter_from_pool",
           {
               fids: this.selected_filters,
              search_field: this.$route.params.search_field,
               basicFilters : this.basicFilters,
                   pool : this.$route.params.pool,
                   minscore : this.minscore
           },
           {
             headers: {
                 'Content-Type': 'application/json',
           }
         }).then( (r) => {
         console.log('callback',r.data);
         this.startups = r.data;
         this.startups_quicksearch = this.startups;
         api.get(process.env.VUE_APP_API_URL+"/search_field/isAssess/"+this.$route.params.search_field).then( (r) => {
           console.log("IS ASSESS");
           console.log(r.data);
           this.isAssess = r.data.isAssess;
           this.sfname = r.data.name;
           this.pageInfo.subTitle = (this.pool.isLongList) ? "Long list" : this.pool.name;
           this.pageInfo.mainTitle = this.sfname;
           this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
           this.loading =false;
         }).catch( (e) => {console.log(e)});
       }).catch( (e) => {console.log(e)});
     });
       }).catch( (e) => {console.log(e)});


  },
  watch: {
     selected_filters: function (v) {
       // Set the value in a cookie every time the variable changes
       localStorage.setItem('currentFilterSet', JSON.stringify(v));
     },
     basicFilters: {
        handler: function (v) {

          if(this.dict_loaded){
              console.log("Watched value",v);
              localStorage.setItem('currentBasicFilterSet', JSON.stringify(v));
          }

       },
       deep: true,
     },
     showSidePanelBasic: function(){
       this.basicFilters = this.basicFilters.map(obj => ({
         ...obj,
         toggled: false
       }));
     },
     quicksearch: function(v){
       console.log(v);
         this.startups_quicksearch = this.startups.filter(obj =>
        obj.name.toLowerCase().includes(v.toLowerCase())
      );
    },
     // minscore : function(v){
     //   console.log(v);
     //   this.apply_filter();
     //
     // }

   },

}
</script>
<style scoped>

.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding-left:0 !important;
  padding-right: 0 !important;
  padding-top:50px;
  padding-bottom:50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-bottom-left-radius: 8px;
border-bottom-right-radius: 8px;
}
.chart-container {
  position: relative;
}

.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}

.prev_step_btn,
.prev_step_btn:hover{
  border: 1px solid #3783C5;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.canvasjs-chart-credit{
  display:none;
}

.mt50{
  margin-top:50px;
}
.mb50{
  margin-bottom: 50px;
}
.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 2px solid #DDDDDD;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.clickable{
  cursor:pointer;
}
.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}

.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}


.titre{
  margin-bottom: 20px;
  color: #3783C5;
  text-transform: uppercase;
}


.checkbox {
  cursor: pointer;
  display: flex;
  align-items: center;
  /* margin-bottom:20px; */
}
.checkboxItem{
  margin-bottom: 20px;
}
.checkbox__input {
  position: absolute;
  width: 1.375em;
  height: 1.375em;
  opacity: 0;
  cursor: pointer;
}
.checkbox__input:checked + .checkbox__icon .tick {
  stroke-dashoffset: 0;
}
.checkbox__icon {
  width: 1.375em;
  height: 1.375em;
  flex-shrink: 0;
  overflow: visible;
}
.checkbox__icon .tick {
  stroke-dasharray: 20px;
  stroke-dashoffset: 20px;
  transition: stroke-dashoffset 0.2s ease-out;
}
.checkbox__label {
  margin-left: 0.5em;
}

.filtres{

  padding:0;
}
.filtres_head .customH2{
  display: block;
  width: 100%;
  background: #3783C5;
  color: #FFF;
  padding: 10px;
}
.filtre_list{
  padding:10px;
}


.prev_step_btn_small{
  border: 1px solid #3783C5;
  border-radius: 200px;
  opacity: 1;
  padding: 5px 20px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.next_step_btn_small, .next_step_btn_small:hover {
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 200px;
  opacity: 1;
  padding: 5px 20px;
  color: #FFF;
  margin: auto;
  display:block;
  margin-top:20px;
  margin-bottom: 20px;
}
.startup_zone_legend{
  align-self: top;
}
.zone_startups{
    align-self: center;
}
.zone_title{
  font-size: 25px;
  color: #3783C5;
  font-weight: 700;
  text-align: center;
  display:block;
  width:100%;
  text-align:center;

}
.zone_number{
  font-size: 16px;
  color: #3783C5;
  font-weight: 700;
  text-align: center;
  display:block;
  width:100%;
  text-align:center;

}

.row.zone{
  padding-bottom: 50px;
  padding-top:25px;
}

.startup_zone_legend.stickit .legend{
  position: sticky;
    top: 50%; /* Adjust the top value as needed */
}

.startup_zone_legend:not(.stickit){
  align-self: center;
}

.alert{
  margin:0;
}



.startup_selection_section{
  position:relative;
}

.filtre_list{
  display: grid;
    grid-template-columns: auto auto auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-rows: 100%;
    gap:10px;
}

.pad-50{
  padding-left:50px;
  padding-right:50px;
}
@media screen and (max-width: 690px){
  .candidate_card .candidate_links{
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px
  }
  .candidate_pool{
      padding: 20px;
    }
    .candidate_card .candidate_links .details{
      border-right: none;
      border-bottom:1px solid #DDD;
      padding-bottom: 20px;
    }
    .candidate_card .candidate_links .selectIt label{
    display:flex;
    align-items: center;
    gap: 5px;
    justify-content: start;
    flex-direction: row-reverse;
    }
    .filtre_list {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-rows: 100%;
  gap: 10px;
}
}


.candidate_comments{
  padding: 20px 50px;
  border-top: 1px solid #DDD;
  margin-top:auto;
}
.candidate_comments .one_comment{
  margin-top:10px;
  margin-bottom: 10px;
  font-size:12px;
  line-height:15px;
    position:relative;
}
.candidate_comments .one_comment:after {
  content: ""; /* This is necessary for the pseudo element to work. */
     display: block; /* This will put the pseudo element on its own line. */
     margin: 0 ; /* This will center the border. */
     width: 20%; /* Change this to whatever width you want. */
     padding-top: 10px; /* This creates some space between the element and the border. */

     border-bottom: 1px solid #CCC; /* This creates the border. Replace black with whatever color you want. */
}
.candidate_comments small{
  font-size:12px;
}

.add_new_comment{
  font-size:12px;
  line-height:15px;
  color: #3785C5;
  text-transform: uppercase;
  margin-top:20px;
}
.add_new_comment img{
  width: 20px;
  margin-right: 10px;
}


.all_candidates_download_zone{
    padding: 50px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
margin-bottom:50px;
}


.title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
margin-bottom: 10px;
}


.all_candidates_download_zone .title{

  font-size: 20px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
margin-bottom: 10px;
font-weight:500;
cursor : pointer;
}


.all_candidates_download_zone .description{
  display:block;
  margin-top:10px;
  margin-bottom: 20px;
  width:100%;
}
.all_candidates_download_zone a{
  color:#B38D2F !important;
}

.next_step_btn{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 200px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}
.next_step_btn img.left{
  margin-right:10px;
}
img.goFullWhite{
filter: brightness(0) invert(1);
}

.pool_subtitle{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
display:block;
}
.mb10{
  margin-bottom:10px;
}
.mt20{
  margin-top:20px;
}


/* .selectAll{
  border: 1px solid #CCC;
  border-radius: 200px;
  padding: 5px 20px;
  margin: auto;
    margin-top: auto;
  display: block;
  margin-top: 20px;
} */
.goToRight{

}

.candidate_card_head{
  background: transparent linear-gradient(270deg, #3783C5 0%, #1368B2 100%) 0% 0% no-repeat padding-box;
  flex-wrap: wrap;
  padding: 10px;
  color: #FFF;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 10px 10px 0px 0px;
  display:flex;
  align-content: center;
    align-items: center;
gap:10px;
min-height: 60px;
}
.candidate_card_head .name{
  flex:1;
}

.score {
  height: 70px;
  width: 70px;
  -webkit-clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
  clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
  text-align: center;
  background: #B38D2F;
  color: white;
  font-size:17px;
}

.score::before {
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  content: '';
}
.candidate_card .candidate_info_content{
  padding:20px;
  flex-grow: 1;
}
.footer{
padding-left: 20px;
  padding-right: 20px;
    padding-bottom: 10px;
  font-weight:bold;
  text-transform: uppercase;
  color:#B38D2F !important;
  font-size:14px;
  display:flex;
  flex-wrap:wrap;
  gap:10px;
}

.footer a{
  margin-left: auto;
}
.footer *{
  color:#4c81c0 !important;
  font-size:14px;
}
.filtre_list .zone_input{
  position:relative;
}
.filter_content{
  position: absolute;
  top: calc(100% + 10px);
  z-index: 900;
  border: 1px solid #4c81c0;
  padding: 20px;
  display:flex;
  flex-direction: column;
  width:400px;
  gap:15px;
  background: #FFF;
  left: calc(50% - 200px);
  box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
-webkit-box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
-moz-box-shadow: 2px 3px 10px 2px rgba(0,0,0,0.28);
}
.mt30{
  margin-top:30px;
}
@media screen and (max-width:990px){
  .filter_content{
    left:-20px;
    right:-20px;
    width:350px;
}
}

.filter_content .value_possible{
  max-height:300px;
  overflow: scroll;
}
.filter_content .btn_invert{
  padding:10px;
  color:#4c81c0;
  background:#FFF;
  font-size:12px;
  border-radius: 20px;
  border:1px solid #4C81C0;
}

.filter_content .btn{
  padding:10px;
  background:#4c81c0;
  color:#FFF;
  font-size:12px;
  border-radius: 20px;
    border:1px solid #4C81C0;
}
.filter_content .flexBottom{
  display: flex;
    gap: 10px;
    flex-wrap: wrap;
align-self: end;
  margin-top:auto;
  align-items: center;
  width:100%;
}
.zone_input_header{
    border: 1px solid #3783C5;
    background: transparent;
    padding: 10px 20px;
    border-radius: 200px;
    outline: none;
    color: #3783C5;
    font-weight: bold;
    letter-spacing: 1px;
}
.zone_input{
  width:100% !important;
  position:relative;
}


.filtre_list_3{
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
  border-left: 2px solid #CCC;
  padding-left: 20px;
}
.filtre_list_2{
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 20px;
  /* justify-content: center;*/
  align-items: center;
  flex-grow:1;
}

.nb_item{
  background: #B38D2F;
  padding: 2px 10px;
  border-radius: 5px;
  font-size: 10px;
  color:#FFF;
  vertical-align: middle;
  margin-right: 5px;
}
.dflex{
  display: flex;
  gap: 10px;
justify-content: stretch;
}

.checkbox{
  position:relative;
}
.checkbox_hover{
  background:#FFF;
  font-size:10px;
  display:none;
}

.checkboxItem:hover  .checkbox_hover{
  display:block;
}
.onecondition{
  width:100%;
  display:block;
}

.website{
  color:#4c81c0 !important;
  font-size:14px;
  text-align:center;
  margin-bottom:20px;
  font-weight:700;
}
.website a{
  color:#4c81c0 !important;
}
.showComments{
  cursor:pointer;
  position:relative;
}

.showComments img{
  width:30px;
}
.sidePannel{
  position: fixed;
  right: 0;
  width: min(100%,500px);
  background: #FFF;
  top: 0;
  height: 100vh;
  z-index: 999;
  overflow: scroll;

}

.oneFilter{
  padding-top: 20px;
  padding-bottom: 20px;
}
.oneFilter:not(:last-child){
border-bottom: 1px solid #ddd;
}
.oneFilter .filtreName{
  margin-bottom:10px;
  display:block;
  color:#4c81c0;
}
.oneFilter .value_possible{
  max-height:300px;
  overflow: scroll; /* Always show both horizontal and vertical scrollbar */
    scrollbar-width: thin; /* Firefox */
    scrollbar-color: #333 #fff; /* Firefox */
}

.oneFilter .value_possible::-webkit-scrollbar {
      width: 12px; /* Width of the scrollbar */
    }

.oneFilter .value_possible::-webkit-scrollbar-thumb {
      background-color: #333; /* Color of the thumb */
    }
.oneFilter .value_possible::-webkit-scrollbar-track {
      background-color: #fff; /* Color of the track */
    }

    .sidePannel .filters{
      overflow: scroll;
  padding: 30px;
  height: calc(100vh - 100px);
    }

  .sidePannel .create_filters{
    overflow: scroll;
padding: 30px;
height: calc(100vh);
  }
    .footerPannel{
      position: static;
  height: 100px;
  border-top: 2px solid #4c81c0;
  padding:20px;
  text-align:right;
    }

      .footerPannel .btn{
      padding:5px 10px;
      background:#4c81c0;
      color:#FFF;
      font-size:15px;
      border-radius: 20px;
      border:1px solid #4C81C0;
      margin:10px;
    }

    .footerPannel .btn_invert{
    padding:5px 10px;
    color:#4c81c0;
    background:#FFF;
    font-size:15px;
    border-radius: 20px;
    border:1px solid #4C81C0;
    margin:10px;
  }
  .triangle{
    width:15px;
  }

  .triangle.open{
    transform:rotate(180deg);
  }

    .candidate_card.isChecked{
      border-color:#4C81C0;
    }


  /* .candidate_card.isAssess{
    border-color:#ad8e41;
  } */
  /* .candidate_card.isAssess .candidate_card_head{
    background:#ad8e41;
  } */
.goRight{
  margin-left:auto;
  display:flex;
  flex-wrap:wrap;
  gap:20px;
}
.extraPoolsContainer{
  position:relative;
}
.extraPoolsIcons{
  width:20px;
}
.extraPoolsNumber{
  background: #B38D2F;
  color: #FFF;
  padding: 0px 6px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: absolute;
  top: -4px;
  right: -10px;
}

.isAssess .extraPoolsNumber{
  color: #B38D2F;
  background: #FFF;
  padding: 0px 6px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: absolute;
  top: -4px;
  right: -10px;
}
.nb_item_comments{
  background: #B38D2F;
  color: #FFF !important;
  padding: 0px 6px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: absolute;
  top: -4px;
  right: -10px;
}

.action_zone{
  position: sticky;
    right: 0;
    top: 0;
    background: #4C81C0;
    padding: 20px 50px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;

}
.new_action_zone {
  position: sticky;
    right: 0;
    top: 0;
    z-index:889;
    background:#FFF;
    padding-top:20px;
    padding-bottom: 20px;
}
.actionZoneTitle{
  color: #FFF;
  font-weight: bold;
  font-size: 20px;
    text-transform: uppercase;
}

.p-rl-50{
  padding-left:50px;
  padding-right:50px;
}

.action_btn,
.action_btn:hover{
  background: #FFF;
  color: #000;
  padding: 5px 15px;
  font-weight: 600;
  border-radius: 200px;
}
.back_btn,
.back_btn:hover{
  background: #FFF;
  color: #000;
  padding: 10px 25px;
  font-weight: 400;
  border-radius: 200px;
}


.zoneBtn{
  position:relative;
  display: flex;

}


.whyDisabled{
  position: absolute;
  background: #EFEFEF;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.enableWhyDisabled:hover .whyDisabled{
  display:block;
}

.hoverInfo{
  position: absolute;
  background: #EFEFEF;
  color:#000 !important;
  padding: 5px;
  width: 120px;
  left: 0px;
  bottom: -5px;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  font-size:12px;
  display:none;
}

.extraPoolsContainer:hover .hoverInfo{
  display:block;
}

.filter_content_title{
  text-transform:uppercase;
  font-weight:600;
}

.v-slider-track__background--opacity {
  opacity: 1;
}



[data-tooltip] {
  cursor: pointer;
  display: inline-block;
  line-height: 1;
  position: relative;
  margin-right: auto;
}
[data-tooltip]::after {
  background-color: rgba(51, 51, 51, 0.9);
  border-radius: 0.3rem;
  color: #fff;
  content: attr(data-tooltip);
  font-size: 1rem;
  font-size: 85%;
  font-weight: normal;
  line-height: 1.15rem;
  opacity: 0;
  padding: 0.25rem 0.5rem;
  position: absolute;
  text-align: center;
  text-transform: none;
  transition: opacity 0.2s;
  visibility: hidden;
  white-space: nowrap;
  z-index: 1;
}
[data-tooltip].tooltip-top::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: rgba(51, 51, 51, 0.9) transparent transparent transparent;
  top: 0;
  left: 50%;
  margin-left: -0.3rem;
}
[data-tooltip].tooltip-top::after {
  bottom: 100%;
  left: 50%;
  transform: translate(-50%);
}
[data-tooltip].tooltip-bottom::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent transparent rgba(51, 51, 51, 0.9) transparent;
  bottom: 0;
  left: 50%;
  margin-left: -0.3rem;
}
[data-tooltip].tooltip-bottom::after {
  top: 100%;
  left: 50%;
  transform: translate(-50%);
}
[data-tooltip].tooltip-left::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent transparent transparent rgba(51, 51, 51, 0.9);
  top: 0.3rem;
  right: calc(110% - 0.3rem);
  margin-top: -0.3rem;
}
[data-tooltip].tooltip-left::after {
  top: -0.3rem;
  right: calc(110% + 0.3rem);
}
[data-tooltip].tooltip-right::before {
  border-style: solid;
  border-width: 0.3rem;
  content: "";
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
  visibility: hidden;
  border-color: transparent rgba(51, 51, 51, 0.9) transparent transparent;
  top: 50%;
  top: 0.3rem;
  left: calc(110% - 0.3rem);
  margin-top: -0.3rem;
}
[data-tooltip].tooltip-right::after {
  top: -0.3rem;
  left: calc(110% + 0.3rem);
}
@media (max-width: 767px) {
  [data-tooltip].tooltip-mobile::before {
    display: none;
  }
  [data-tooltip].tooltip-mobile:after {
    font-size: 1rem;
    max-width: 20rem;
    position: fixed;
    bottom: auto;
    top: 50%;
    left: 50%;
    text-align: left;
    transform: translate(-50%);
    white-space: normal;
  }
}
[data-tooltip]:hover::after, [data-tooltip][class*=tooltip-]:hover::before {
  visibility: visible;
  opacity: 1;
}

.poolTitle .customH2{
  color:#3783C5;
}

.poolTitle .customH2 .sfname{
  font-weight: 700;
  text-transform:uppercase;
}



/* .slider_mini_score{
  max-width: 350px;
  min-width: 300px;
} */

@media screen and (max-width:990px){
  .quicksearch{
    max-width: 100%;
    width:100%;
    margin-top:20px;
    margin-bottom:20px;
  }
  .quicksearch .input{
    max-width: 100%;
    width:100%;
      /* border: 1px solid #fff;
      background: transparent;
      padding: 5px 20px;
      border-radius: 200px;
      outline: none;
      color: #fff;
      font-weight: bold;
      letter-spacing: 1px; */
  }
  .filtre_list_2{
    width:100%;
    flex:1;
  }

  .target_score_container .slider_mini_score{
    flex-direction: column !important;
  }
  .flexItCenterButtons{
    flex-direction: column;

  }
  .whyDisabled{
    z-index: 9999;
  }
}
.moneyEntryLine{
  width: 100%;

}
.moneyEntryName{
    color:#333;
}
.moneyEntryInput{
  flex:1;

}

.moneyEntryLine select{
  -moz-appearance: menulist;
  -webkit-appearance: menulist;
}



@media screen and (min-width:1301px) and (max-width:1650px){
  .candidate {
    flex: 0 0 auto;
    width: calc(100% / 3);
  }

}
@media screen and (min-width:1000px) and (max-width:1300px){
  .candidate {
    flex: 0 0 auto;
    width: 50%;
  }

}


.zindex999{
  z-index:9999;
}


  .quicksearch{
    position:relative;
  }
  .quicksearch .input{
    max-width:300px;
      border: 1px solid #3783C5;
      background: transparent;
      padding: 10px 20px;
      padding-right: 50px;
      border-radius: 200px;
      outline: none;
      color: #3783C5;
      font-weight: bold;
      letter-spacing: 1px;
  }
  .quicksearch::after{
    content: url('@/assets/loupe.svg');
    position:absolute;
    right:15px;
    top:50%;
    transform:translateY(-50%);
  }





  .super_action_zone{
    padding: 20px 50px;
    z-index:889;
    display:flex;
    flex-wrap:wrap;
    background: rgba(55, 131, 197, .07);
  border-radius: 200px;
  margin-right: 20px;
  margin-left: 20px;
  display:flex;
  align-items: center;
  justify-content: space-between;
  gap:20px;
  }


  @media screen and (max-width:690px){
      .super_action_zone{flex-direction: column;gap:20px;    padding: 10px;}
    .quicksearch{
      margin-top:20px;
    }
    .quicksearch .input{
      max-width: 100%;
      width:100%;

    }
    .filtre_list_2{
      width:100%;
      flex:1;
    }
  }
    .tooglerFilter .toogler{
      color:#3982C4;
      font-weight: 400px;
      display:flex;
      gap:10px;
    }


    .numberOfStartupResult{
      text-align:center;
    font-size: 21px;
    line-height:25px ;
letter-spacing: 0px;
color: rgba(55, 131, 197, 1);
text-transform: uppercase;
    }

    .flexItCenterButtons{
      width:100%;
      display:flex;
      justify-content: center;
      align-items: center;
      gap:10px;
      margin-top:0px;
          flex-wrap: wrap;
    }


    .action_btn_pool,
    .action_btn_pool:hover{
      background: rgba(55, 131, 197, 1);
      border:1px solid rgba(55, 131, 197, 1);
      color: #fff;
      padding: 10px 30px;
      font-weight: 600;
      border-radius: 200px;
      text-transform: uppercase;
      font-size:15px;
    }

    .disabledRlink{
      pointer-events: none;
      opacity: 0.7;
    }
    .selectAllCp{
      color: rgba(179, 141, 47, 1);
      border:1px solid rgba(179, 141, 47, 1);
      background: #fff ;
      padding: 10px 30px;
      font-weight: 600;
      border-radius: 200px;
      text-transform: uppercase;
      font-size:15px;
      margin-top:0px;
    }


    .zoneBtn{
      position:relative;
      display: flex;
    width:auto;

    }
        .candidate_card.isChecked{
          border-color:#4C81C0;
        }
        .candidate_card.isChecked .checkbox__icon .fond{
          fill:transparent !important;
        }
        .candidate_card:not(.whitehead).isChecked .checkbox__icon .tick{
          stroke:#FFF !important;
        }

    .detail{
      background: #F1F6FB;
  padding: 10px 20px;
  border-radius: 200px;
  text-align: center;
    }
</style>
<style media="screen" >
  .vcp__header{
    background-color:#3783C5 !important;
    color:#FFF !important;
    padding:20px !important;
  }
  .vcp__body {
 border-top: 1px solid #3783C5 !important;
}
.vcpg{
   border: 1px solid #3783C5 !important;
}
  .vcp__header .customH2{
    font-size:20px;
    line-height:20px;
    margin:0;
  }

  .links_2{
    border-top: 1px solid #DDD;
  }
  .input_filtre{
    border: 1px solid #4c81c0;
    width: 100%;
    padding: 5px;
    margin-bottom: 20px;

  }
  .v-slider-track__background--opacity {
    opacity: 1;
  }

  .flexIt > div{
    display:flex;
  }
  .mlauto{
    margin-left: auto;
  }

  .numberRes{
    font-weight: 400;
    color:#3783c5;
  }

/* .target_score_container{
  position: absolute;
left: 50%;
transform: translateX(-50%);
display: flex;
justify-content: center;
width: 100%;
} */
@media screen and (max-width:890px){
  /* .target_score_container{
    position: relative;
    left: auto;
    transform: none;
    flex: 1;
  } */
  .filtre_list_2{
    justify-content: center;
  }


}

</style>
<style media="screen">
.slider_mini_score{
  display:flex;
  align-items: center;
  gap:20px;
}
.slider_mini_score .textcaption{
  font-size:14px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
opacity: 1;
}
.slider_mini_score .v-input{
  width:350px;
}

.slider_mini_score .v-input__details{
  display:none;
}

.slider_mini_score .v-input__prepend,
.slider_mini_score .v-input__append{
  font-size:14px;
letter-spacing: 0px;
color: #3783C5;
}

.slider_mini_score .v-slider-track__fill{
  background-color: #C4CFEC !important;

}
</style>
